module.exports = __webpack_public_path__ + "img/work1.0c33ca9c.png";